import io from "socket.io-client";
import store from "../stories/store";
import {
    setSessionId, setRoomId, setUsername, setIdentity, setUsersLoggeds,
    setParticipants, setRoomSocketId, setErrorMessage
} from "../stories/actions";
import { appendNewMesageDirectHistory } from "./directUserMessage";
import * as roomRTC from "./roomRTC";

const ORIGIN = process.env.REACT_APP_API_URL;
// const SESSION_ID = process.env.REACT_APP_SESSION_ID;
let socket = null;

export const connectRoomSocketIOServer = async () => {
    socket = io(`${ORIGIN}`, {
        transports: ['websocket'],
        reconnection: true,
        reconnectionAttempts: 10,
        reconnectionDelay: 2000,
    });

    socket.on("connect", () => {
        store.dispatch(setRoomSocketId(socket.id));
    });

    socket.on("session_created", (data) => {
        const { sessionId } = data;
        store.dispatch(setSessionId(sessionId));
    });

    socket.on("session_update", (data) => {
        const { usersLoggeds } = data;
        store.dispatch(setUsersLoggeds(usersLoggeds));
    });

    socket.on("login_denied", (data) => {
        store.dispatch(setErrorMessage(data.message));
    });

    socket.on("room_created", (data) => {
        const { roomId } = data;
        store.dispatch(setRoomId(roomId));
    });

    socket.on("room_update", (data) => {
        const { roomConnecteds } = data;
        store.dispatch(setParticipants(roomConnecteds));
    });

    socket.on("room_prepare", (data) => {
        const { roomConnectedInSocketId } = data;
        roomRTC.prepareRoomPeerConnection(roomConnectedInSocketId, false);

        socket.emit("room_init", { roomConnectedInSocketId: roomConnectedInSocketId });
    });

    socket.on("room_signal", (data) => {
        roomRTC.handlerRoomSignalData(data);
    });

    socket.on("room_init", (data) => {
        const { roomConnectedInSocketId } = data;
        roomRTC.prepareRoomPeerConnection(roomConnectedInSocketId, true);
    });

    socket.on("direct_message", async (data) => {
        await appendNewMesageDirectHistory(data);
    });

    // socket.on("chat_message", ({ sessionId, username, content }) => {
    //     if (!sessionId || !username || !content) return;

    //     io.to(sessionId).emit("chat_message", {
    //         username,
    //         content,
    //         timestamp: new Date()
    //     });
    // });

    socket.on("session_disconnected", (data) => {
        roomRTC.removeSessionPeerConnection(data);
    });

    socket.on("room_disconnected", (data) => {
        roomRTC.removeRoomPeerConnection(data);
    });
};

export const createSession = (isAdmin, username, sessionId) => {
    const data = {
        isAdmin,
        username,
        sessionId
    };

    socket.emit("create_session", data);
    store.dispatch(setUsername(username));
};

export const joinSession = (isAdmin, username, sessionId) => {
    const data = {
        isAdmin,
        username,
        sessionId
    };

    socket.emit("join_session", data);
    store.dispatch(setUsername(username));
};

export const createRoom = (identity, usuarioId, isOnlyAudio, isOnlyCamera, isRoomListener) => {
    const data = {
        identity,
        usuarioId,
        isOnlyAudio,
        isOnlyCamera,
        isRoomListener
    };

    socket.emit("create_room", data);

    store.dispatch(setIdentity(identity));
};

export const joinRoom = (roomId, identity, usuarioId, isOnlyAudio, isOnlyCamera, isRoomListener) => {
    const data = {
        roomId,
        identity,
        usuarioId,
        isOnlyAudio,
        isOnlyCamera,
        isRoomListener
    };

    socket.emit("join_room", data);

    store.dispatch(setIdentity(identity));
};

export const roomSignalPeerData = (data) => {
    socket.emit("room_signal", data);
};

export const sendDirectMessage = (data) => {
    socket.emit("direct_message", data);
};